import { useMemo, useState } from "react";
import DSBox from "views/system-design/DSBox";
import DSTabs from "views/system-design/DSTabs";
import DSTab from "views/system-design/DSTab";
import { Ticket, CalendarViewMode } from "../../types";
import MonthView from "./MonthView";
import WeekView from "./WeekView";

interface TicketsCalendarViewProps {
  tickets: Ticket[];
  onSelectTicket: (ticket: Ticket) => void;
  viewMode: CalendarViewMode;
  onViewModeChange: (mode: CalendarViewMode) => void;
}

export default function TicketsCalendarView({
  tickets,
  onSelectTicket,
  viewMode,
  onViewModeChange,
}: TicketsCalendarViewProps) {
  const [currentDate, setCurrentDate] = useState(() => new Date());

  const ticketsByDay = useMemo(() => {
    const map = new Map<string, Ticket[]>();
    for (const ticket of tickets) {
      if (!ticket.dueDate) continue;
      const dueDate = new Date(ticket.dueDate);
      if (Number.isNaN(dueDate.getTime())) continue;
      const dayKey = dueDate.toDateString();
      const existing = map.get(dayKey);
      if (existing) {
        existing.push(ticket);
      } else {
        map.set(dayKey, [ticket]);
      }
    }
    return map;
  }, [tickets]);

  return (
    <DSBox sx={{ mt: 2 }}>
      <DSBox sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
        <DSTabs
          value={viewMode}
          onChange={(_event, newValue: CalendarViewMode) =>
            onViewModeChange(newValue)
          }
          sx={{
            minHeight: 36,
            "& .MuiTab-root": { minHeight: 36, textTransform: "none" },
          }}
        >
          <DSTab value="week" label="Weekly" />
          <DSTab value="month" label="Monthly" />
        </DSTabs>
      </DSBox>
      {viewMode === "month" ? (
        <MonthView
          currentDate={currentDate}
          onDateChange={setCurrentDate}
          ticketsByDay={ticketsByDay}
          onSelectTicket={onSelectTicket}
        />
      ) : (
        <WeekView
          currentDate={currentDate}
          onDateChange={setCurrentDate}
          ticketsByDay={ticketsByDay}
          onSelectTicket={onSelectTicket}
        />
      )}
    </DSBox>
  );
}
